import React from 'react';
import InfoModal from '../Modals/InfoModal'; // Mantén el InfoModal
import useModals from '../../hooks/useModals'; // Mantén el hook de modales
import WarningModal from '../Modals/WarningModal';
import WelcomeModal from '../Modals/WelcomeModal';
import SuccessModal from './SuccessModal';
import ErrorModal from './ErrorModal';
import ServerErrorModal from './ServerErrorModal';
import PendingModal from './PendingModal';

const ModalDisplay: React.FC = () => {
  const { modalType, modalProps, closeModal } = useModals();

  if (modalType === 'success') {
    return (
      <SuccessModal
        isOpen={true}
        onClose={closeModal}
        title={modalProps.title}
        message={modalProps.message}
      />
    );
  }

  if (modalType === 'serverError') {
    return (
      <ServerErrorModal
        isOpen={true}
        onClose={closeModal}
        title={modalProps.title}
        message={modalProps.message}
      />
    );
  }

  if (modalType === 'error') {
    return (
      <ErrorModal
        isOpen={true}
        onClose={closeModal}
        title={modalProps.title}
        message={modalProps.message}
      />
    );
  }

  // Muestra el modal de información
  if (modalType === 'info') {
    return (
      <InfoModal
        isOpen={true}
        onClose={closeModal}
        title={modalProps.title}
        message={modalProps.message}
      />
    );
  }

  // Muestra el nuevo modal de confirmación
  if (modalType === 'warning') {
    return (
      <WarningModal
        isOpen={true}
        onClose={closeModal}
        title={modalProps.title} // Título del modal
        message={modalProps.message} // Mensaje del modal
      />
    );
  }

  // Muestra el modal de bienvenida
  if (modalType === 'welcome') {
    return (
      <WelcomeModal
        isOpen={true}
        onClose={closeModal}
        username={modalProps.username} // Pasamos el nombre de usuario para el saludo
      />
    );
  }

  if (modalType === 'pending') {
    return (
      <PendingModal
        isOpen={true}
        title={modalProps.title}
        message={modalProps.message}
      />
    );
  }

  return null;
};

export default ModalDisplay;
